import {select as d3select, mouse as d3mouse} from 'd3-selection';
import {format as d3format} from 'd3-format';
import {arc as d3arc} from 'd3-shape';

import Model from '../Model/Model';
import Dispatch from '../Dispatch/Dispatch';
import State from '../State/State';

import './Tooltip.css';

var container = d3select('#world-map');
var tooltip = d3select('.WorldMap-tooltip');
var numberFormat = d3format(',');
var f = d => numberFormat(Math.round(d));

var arcGenerator = d3arc().innerRadius(0).outerRadius(23);


function init() {
	Dispatch.dispatch.on('hoveredCountryUpdate.Tooltip', update);
	Dispatch.dispatch.on('mapMousemove.Tooltip', updatePosition);
}

function updatePosition() {

	var pos = d3mouse(container.node());
	var offset = 10;

	var x = pos[0] + offset;
	var y = 490 - pos[1];

	tooltip.style('left', x + 'px').style('bottom', y + 'px')
}

function updatePanelMode() {
	container.selectAll('.WorldMap-tooltip-inner')
		.style('display', 'none');

	switch(State.selectedSeries) {
	case 'cases':
		container.selectAll('.WorldMap-tooltip-cases')
			.style('display', 'inline');
		break;

	case 'deaths':
		container.selectAll('.WorldMap-tooltip-deaths')
			.style('display', 'inline');
		break;

	case 'dalys':
		container.selectAll('.WorldMap-tooltip-dalys')
			.style('display', 'inline');
		break;

	default:
		break;
	}
}

// Pie chart
function computeAngles(values) {
	var total = values.shigella.value + values.etec.value;
	var mid = 2 * Math.PI * values.shigella.value / total;

	values.shigella.startAngle = 0;
	values.shigella.endAngle = mid;
	values.etec.startAngle = mid;
	values.etec.endAngle = 2 * Math.PI;
}

function computePercents(values) {
	var ret = {
		etec: {
			value: values.etec
		},
		shigella: {
			value: values.shigella
		}
	};

	var total = values.shigella + values.etec;
	ret.shigella.percent = 100 * values.shigella / total;
	ret.etec.percent = 100 * values.etec / total;
	return ret;
}

function updatePie(selector, values) {
	computeAngles(values);
	
	tooltip
		.select(selector)
		.select('.WorldMap-tooltip-segment-etec')
		.attr('d', arcGenerator(values.etec));

	tooltip
		.select(selector)
		.select('.WorldMap-tooltip-segment-shigella')
		.attr('d', arcGenerator(values.shigella));
}


// Dalys pie chart (special case)
function computeDalysAngles(values) {
	var total = values.shigella.value + values.etec.value + values.stunting.value;
	var mid1 = 2 * Math.PI * values.shigella.value / total;
	var mid2 = 2 * Math.PI * (values.shigella.value + values.etec.value) / total;

	values.shigella.startAngle = 0;
	values.shigella.endAngle = mid1;
	values.etec.startAngle = mid1;
	values.etec.endAngle = mid2;
	values.stunting.startAngle = mid2;
	values.stunting.endAngle = 2 * Math.PI;
}

function computeDalysPercents(values) {
	var ret = {
		etec: {
			value: values.etec
		},
		shigella: {
			value: values.shigella
		},
		stunting: {
			value: values.stunting
		}
	};

	var total = values.shigella + values.etec + values.stunting;
	ret.shigella.percent = 100 * values.shigella / total;
	ret.etec.percent = 100 * values.etec / total;
	ret.stunting.percent = 100 * values.stunting / total;

	return ret;
}

function updateDalysPie(selector, values) {
	computeDalysAngles(values);
	
	tooltip
		.select(selector)
		.select('.WorldMap-tooltip-segment-etec')
		.attr('d', arcGenerator(values.etec));

	tooltip
		.select(selector)
		.select('.WorldMap-tooltip-segment-shigella')
		.attr('d', arcGenerator(values.shigella));

	tooltip
		.select(selector)
		.select('.WorldMap-tooltip-segment-stunting')
		.attr('d', arcGenerator(values.stunting));
}


function updateCasesContent() {
	var country = Model.dataLU[State.hoveredCountry];
	var inner = tooltip.select('.WorldMap-tooltip-cases');

	inner.select('.WorldMap-tooltip-total .WorldMap-tooltip-value')
		.text(f(country['Cases ETEC and Shigella']));

	var etec = +country['Cases ETEC'];
	var shigella = +country['Cases Shigella'];
	var percents = computePercents({ etec: etec, shigella: shigella});

	updatePie('.WorldMap-tooltip-cases', percents);

	inner.select('.WorldMap-tooltip-shigella .WorldMap-tooltip-value')
		.text(f(percents.shigella.percent) + '%');

	inner.select('.WorldMap-tooltip-etec .WorldMap-tooltip-value')
		.text(f(percents.etec.percent) + '%');
}

function updateDeathsContent() {
	var country = Model.dataLU[State.hoveredCountry];
	var inner = tooltip.select('.WorldMap-tooltip-deaths');

	inner.select('.WorldMap-tooltip-direct .WorldMap-tooltip-value')
		.text(f(country['Direct deaths ETEC and Shigella']));

	inner.select('.WorldMap-tooltip-indirect .WorldMap-tooltip-value')
		.text(f(country['Indirect deaths ETEC and Shigella']));

	var etec = +country['Direct deaths ETEC'];
	var shigella = +country['Direct deaths Shigella'];
	var percents = computePercents({ etec: etec, shigella: shigella});

	updatePie('.WorldMap-tooltip-deaths', percents);

	inner.select('.WorldMap-tooltip-shigella .WorldMap-tooltip-value')
		.text(f(percents.shigella.percent) + '%');

	inner.select('.WorldMap-tooltip-etec .WorldMap-tooltip-value')
		.text(f(percents.etec.percent) + '%');
}

function updateDalysContent() {
	var country = Model.dataLU[State.hoveredCountry];
	var inner = tooltip.select('.WorldMap-tooltip-dalys');

	var burden = State.includeStunting ? country['DALYs direct and stunting ETEC and Shigella'] : country['DALYs direct ETEC and Shigella'];
	inner.select('.WorldMap-tooltip-burden .WorldMap-tooltip-value')
		.text(f(burden));

	var equivalent = country['DALYs lifetimes equivalent'];
	inner.select('.WorldMap-tooltip-equivalent .WorldMap-tooltip-value')
		.text(f(equivalent));

	var rate = 100000 * burden / country['Population (<5)'];
	inner.select('.WorldMap-tooltip-rate .WorldMap-tooltip-value')
		.text(f(rate));

	var etec = +country['DALYs direct ETEC'];
	var shigella = +country['DALYs direct Shigella'];
	var stunting = State.includeStunting ? +country['DALYs stunting ETEC and Shigella'] : 0;
	var percents = computeDalysPercents({ etec: etec, shigella: shigella, stunting: stunting});

	updateDalysPie('.WorldMap-tooltip-dalys', percents);

	inner.select('.WorldMap-tooltip-shigella .WorldMap-tooltip-value')
		.text(f(percents.shigella.percent) + '%');

	inner.select('.WorldMap-tooltip-etec .WorldMap-tooltip-value')
		.text(f(percents.etec.percent) + '%');

	inner.select('.WorldMap-tooltip-stunting')
		.style('opacity', State.includeStunting ? 1 : 0)
		.select('.WorldMap-tooltip-value')
		.text(f(percents.stunting.percent) + '%');

	inner.select('.WorldMap-tooltip-earnings .WorldMap-tooltip-value')
		.text('US$' + f(+country['Life earnings lost'] / 1e6) + ' million');
}

function updatePanelContent() {
	switch(State.selectedSeries) {
	case 'cases':
		updateCasesContent();
		break;

	case 'deaths':
		updateDeathsContent();
		break;

	case 'dalys':
		updateDalysContent();
		break;

	default:
		break;
	}

}

function update() {
	if(State.hoveredCountry === null) {
		tooltip.style('display', 'none');
		return;
	}

	updatePanelMode();
	updatePanelContent();

	var country = Model.dataLU[State.hoveredCountry];

	tooltip.style('display', 'inline');

	tooltip.selectAll('.WorldMap-tooltip-name')
		.text(country.Country);

	tooltip.selectAll('.WorldMap-tooltip-population .WorldMap-tooltip-value')
		.text(f(country['Population (<5)']));
}


var api = {
	init: init
};

export default api;


/** WEBPACK FOOTER **
 ** ./src/Tooltip/Tooltip.js
 **/